<ion-header class="ion-no-border">
    
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title *ngIf="event">
            {{event.title}}
            <p class="subtitle">Ticket types</p>
        </ion-title>
    </ion-toolbar>

</ion-header>

<ion-content>

    <ion-list *ngIf="ticket_types && ticket_types.length != 0">
        <ion-item *ngFor="let ticket_type of ticket_types" detail="true" button="true" lines="full" (click)="ticketTypeClicked(ticket_type)">
            <ion-label>
                <h3 class="ion-text-wrap">{{ticket_type.title}}</h3>
                <ion-grid class="ion-no-padding">
                    <ion-row>
                        <ion-col *ngIf="ticket_type.sell_price" size="auto">
                            <h5>Price</h5>
                            <p class="prominent">{{cart.currency.sign}}{{ticket_type.sell_price | number:'1.2'}}</p>
                        </ion-col>
                        <ion-col size="auto">
                            <h5>Tickets sold</h5>
                            <p class="prominent">{{ticket_type.ticket_count}}</p>
                        </ion-col>
                        <ion-col *ngIf="ticket_type.tickets_remaining" size="auto">
                            <h5>Tickets left</h5>
                            <p class="prominent">
                                <span *ngIf="ticket_type.tickets_remaining > ticket_type.low_ticket_threshold" class="success">{{ticket_type.tickets_remaining}}</span>
                                <span *ngIf="ticket_type.tickets_remaining <= ticket_type.low_ticket_threshold && ticket_type.tickets_remaining > 0" class="warning">{{ticket_type.tickets_remaining}}</span>
                                <span *ngIf="ticket_type.tickets_remaining != undefined && ticket_type.tickets_remaining <= 0" class="danger">{{ticket_type.tickets_remaining}}</span>
                            </p>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </ion-label>
        </ion-item>
    </ion-list>

    <ion-grid *ngIf="ticket_types && ticket_types.length == 0" class="nothing-found">
        <ion-row class="ion-align-items-center ion-justify-content-center">
            <ion-col>
                <p>
                    <fa-icon [icon]="['fal', 'ticket']" size="6x"></fa-icon>
                    <span>No ticket types found</span>
                </p>
            </ion-col>
        </ion-row>
    </ion-grid>

</ion-content>